import { render } from "./LeadDashboardView.vue?vue&type=template&id=72a33c26&scoped=true"
import script from "./LeadDashboardView.vue?vue&type=script&lang=js"
export * from "./LeadDashboardView.vue?vue&type=script&lang=js"

import "./LeadDashboardView.vue?vue&type=style&index=0&id=72a33c26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a33c26"]])

export default __exports__